import { useEffect, useRef, useCallback } from 'react'

// Debounces a callback (not a value — see useDebounce for that). Always
// invokes the latest `callback` passed in, even if the debounced function
// reference itself is stable across renders.
export const useDebouncedCallback = (callback, delayMs) => {
  const callbackRef = useRef(callback)
  const timeoutRef = useRef(null)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => () => clearTimeout(timeoutRef.current), [])

  return useCallback(
    (...args) => {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => callbackRef.current(...args), delayMs)
    },
    [delayMs]
  )
}
